import { Token } from "@/config/tokens"
import InvoiceEdit from "./invoice-edit"
import { InvoiceStatus } from "@/api/invoices"
import { getNetworksForToken } from "@/config"

export default function InvoiceCreateScreen() {
  return (
    <InvoiceEdit
      invoice={{
        status: InvoiceStatus.DRAFT,
        networks: getNetworksForToken(Token.USDC),
        token: Token.USDC,
        date: new Date(),
        items: [
          {
            description: "",
            unitValue: "",
            quantity: "1",
          },
        ],
        sendToEmails: [],
      }}
    />
  )
}
